/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-02 22:20:45
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import ElementUI from "element-ui";

Vue.config.productionTip = false;
Vue.use(ElementUI);
// 全局api
import "./api/axios";
// 全局路由权限
import "./permission";
//全局数据格式化
import filter from "./filter";
import Plugins from "@/filter.js";
Vue.prototype.Plugins = Plugins;
Object.keys(filter).forEach(key => Vue.filter(key, filter[key]));
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js